import { render, staticRenderFns } from "./StudentDevelopmentReport.vue?vue&type=template&id=3c10faab&scoped=true"
import script from "./StudentDevelopmentReport.vue?vue&type=script&lang=js"
export * from "./StudentDevelopmentReport.vue?vue&type=script&lang=js"
import style0 from "./StudentDevelopmentReport.vue?vue&type=style&index=0&id=3c10faab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c10faab",
  null
  
)

export default component.exports